import { Component, Input, Output, OnInit, OnDestroy, EventEmitter, ChangeDetectorRef , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CdkDragDrop, moveItemInArray, DragDropModule } from "@angular/cdk/drag-drop";
import { ToastrService } from "ngx-toastr";
import { IItemConfig } from "../../../interfaces/iitemconfig";
import { DropDownItem } from "../../../models/dropdown";

import { ItemConfigService } from "../../../services/itemconfig.service";
import { Router } from "@angular/router";
import { ItemConfigHierachyService } from "../../../services/itemconfighierachy.service";
import { FormBuilder } from "@angular/forms";
import { ItemConfigListItemComponent } from "../itemconfiglistitem/itemconfiglistitem.component";

@Component({
    selector: "itemconfiglist",
    templateUrl: "./itemconfiglist.component.html",
    styles: [`
        .drag-item {
            cursor: pointer;
            transition: transform 0.2s ease;
        }
        
        .drag-handle {
            cursor: pointer;
            padding: 4px;
            color: #6c757d;
            font-size: 16px;
        }
        
        .drag-handle:hover {
            color: #007bff;
        }
        
        .drag-handle:active {
            cursor: grabbing;
        }
        
        /* CDK-specific styles temporarily commented out
        .cdk-drag-preview {
            box-sizing: border-box;
            border-radius: 4px;
            box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
                        0 8px 10px 1px rgba(0, 0, 0, 0.14),
                        0 3px 14px 2px rgba(0, 0, 0, 0.12);
            background: white !important;
            color: #333 !important;
            opacity: 0.9;
            transform: rotate(2deg);
            border: 1px solid #e0e0e0;
        }
        
        .cdk-drag-preview * {
            background: white !important;
            color: #333 !important;
        }
        
        .cdk-drag-preview::before,
        .cdk-drag-preview::after {
            display: none !important;
        }
        
        .cdk-drag-preview .drag-handle {
            color: #6c757d !important;
        }
        
        .cdk-drag-placeholder {
            opacity: 0.4;
            background: #f8f9fa;
            border: 2px dashed #dee2e6;
        }
        
        .cdk-drag-animating {
            transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
        }
        
        .draggable.cdk-drop-list-dragging .draggable-item:not(.cdk-drag-placeholder) {
            transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
        }
        */
        
        .draggable-item-disabled {
            opacity: 0.7;
        }
        
        .draggable-item-disabled .drag-handle {
            cursor: not-allowed;
            color: #dc3545;
        }
        
        /* Fix the black dot issue - use div instead of ul/li */
        .draggable {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
        
        .draggable-item {
            display: block;
            padding: 8px;
            border: 1px solid #dee2e6;
            border-radius: 4px;
            background: white;
            transition: all 0.2s ease;
        }
        
        .draggable-item:hover {
            border-color: #007bff;
            box-shadow: 0 2px 4px rgba(0,123,255,0.1);
        }
        
        .draggable-item-disabled {
            opacity: 0.6;
            background: #f8f9fa;
        }
        
        /* Override any CDK default styles that might show black elements */
        :host ::ng-deep .cdk-drag-preview {
            background: white !important;
            color: #333 !important;
        }
        
        :host ::ng-deep .cdk-drag-preview * {
            background: white !important;
            color: #333 !important;
        }
        
        :host ::ng-deep .cdk-drag-preview::before,
        :host ::ng-deep .cdk-drag-preview::after {
            display: none !important;
        }
        
        /* Hide any bullet points or list markers */
        :host ::ng-deep .cdk-drag-preview ul,
        :host ::ng-deep .cdk-drag-preview li {
            list-style: none !important;
            list-style-type: none !important;
        }
        
        /* Ensure drag handle is visible in preview */
        :host ::ng-deep .cdk-drag-preview .drag-handle {
            color: #6c757d !important;
            background: transparent !important;
        }
        
        /* Remove any default list styling that might show as dots */
        :host ::ng-deep ul.draggable {
            list-style: none !important;
            list-style-type: none !important;
            padding-left: 0 !important;
        }
        
        :host ::ng-deep .draggable li {
            list-style: none !important;
            list-style-type: none !important;
        }
        
        /* Ensure FontAwesome icons display correctly in drag preview */
        :host ::ng-deep .cdk-drag-preview .fa {
            color: #6c757d !important;
            background: transparent !important;
        }
        
        :host ::ng-deep .cdk-drag-preview .fa-bars {
            color: #6c757d !important;
        }
        
        :host ::ng-deep .cdk-drag-preview .fa-angle-right,
        :host ::ng-deep .cdk-drag-preview .fa-angle-down {
            color: #6c757d !important;
        }
        
        /* Aggressive removal of any dots, bullets, or dark elements */
        :host ::ng-deep .cdk-drag-preview,
        :host ::ng-deep .cdk-drag-preview *,
        :host ::ng-deep .cdk-drag-preview *::before,
        :host ::ng-deep .cdk-drag-preview *::after {
            background: white !important;
            color: #333 !important;
            list-style: none !important;
            list-style-type: none !important;
            list-style-image: none !important;
            list-style-position: outside !important;
        }
        
        /* Remove all possible pseudo-elements */
        :host ::ng-deep .cdk-drag-preview *::before,
        :host ::ng-deep .cdk-drag-preview *::after,
        :host ::ng-deep .cdk-drag-preview::before,
        :host ::ng-deep .cdk-drag-preview::after {
            content: none !important;
            display: none !important;
        }
        
        /* Force override any inherited list styles */
        :host ::ng-deep .cdk-drag-preview ul,
        :host ::ng-deep .cdk-drag-preview ol,
        :host ::ng-deep .cdk-drag-preview li {
            list-style: none !important;
            list-style-type: none !important;
            list-style-image: none !important;
            margin: 0 !important;
            padding: 0 !important;
            background: white !important;
        }
        
        /* Ensure all text and icons are visible */
        :host ::ng-deep .cdk-drag-preview .fa,
        :host ::ng-deep .cdk-drag-preview i {
            color: #6c757d !important;
            background: transparent !important;
        }
        
        /* Remove any borders or outlines that might appear as dots */
        :host ::ng-deep .cdk-drag-preview *,
        :host ::ng-deep .cdk-drag-preview {
            border: none !important;
            outline: none !important;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;
        }
        
        /* Alternative approach: Hide the entire preview and use a custom one */
        :host ::ng-deep .cdk-drag-preview {
            background: white !important;
            border: 1px solid #ddd !important;
            border-radius: 4px !important;
            padding: 8px !important;
            font-family: inherit !important;
            font-size: 14px !important;
            color: #333 !important;
            box-shadow: 0 4px 8px rgba(0,0,0,0.15) !important;
            transform: rotate(2deg) !important;
            opacity: 0.9 !important;
        }
        
        /* Override CDK's default drag preview completely */
        :host ::ng-deep .cdk-drag-preview * {
            all: unset !important;
            color: #333 !important;
            background: transparent !important;
            font-family: inherit !important;
        }
        
        /* Restore only the necessary styles for FontAwesome icons */
        :host ::ng-deep .cdk-drag-preview .fa {
            font-family: FontAwesome !important;
            color: #6c757d !important;
            background: transparent !important;
        }
        
        /* Nuclear option: completely override the drag preview */
        :host ::ng-deep .cdk-drag-preview {
            background: white !important;
            color: #333 !important;
            border: 1px solid #ccc !important;
            border-radius: 4px !important;
            padding: 10px !important;
            box-shadow: 0 2px 10px rgba(0,0,0,0.2) !important;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
            font-size: 14px !important;
            line-height: 1.4 !important;
            opacity: 0.9 !important;
            transform: rotate(2deg) !important;
            max-width: 300px !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
            white-space: nowrap !important;
        }
        
        /* Hide absolutely everything that could create dots */
        :host ::ng-deep .cdk-drag-preview *::before,
        :host ::ng-deep .cdk-drag-preview *::after {
            content: "" !important;
            display: none !important;
            visibility: hidden !important;
        }
        
        /* Custom drag preview styling */
        .custom-drag-preview {
            background: white !important;
            border: 1px solid #ddd !important;
            border-radius: 4px !important;
            padding: 8px 12px !important;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
            font-size: 14px !important;
            color: #333 !important;
            display: flex !important;
            align-items: center !important;
            gap: 8px !important;
            max-width: 250px !important;
            opacity: 0.95 !important;
            transform: rotate(1deg) !important;
        }
        
        .drag-handle-preview {
            color: #6c757d !important;
            font-size: 14px !important;
            background: transparent !important;
        }
        
        .item-name-preview {
            color: #333 !important;
            background: transparent !important;
            font-weight: 500 !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
            white-space: nowrap !important;
        }
    `],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, ItemConfigListItemComponent, DragDropModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class ItemConfigListComponent implements OnInit, OnDestroy {
    @Input() items: IItemConfig[];
    @Input() dropdownOptions: DropDownItem[];
    @Input() hideDisableItems: boolean;
    @Output() configItemDeleted: EventEmitter<IItemConfig> = new EventEmitter();
    @Output() itemsReordered: EventEmitter<IItemConfig[]> = new EventEmitter(); // Add this output
    drake: any;

    constructor(private toastr: ToastrService,
        private itemConfigService: ItemConfigService,
        private router: Router,
        private builder: FormBuilder,
        private itemConfigHierachyService: ItemConfigHierachyService,
        private cdr: ChangeDetectorRef
    ) { }

    /**
     * Get visible items (excluding hidden disabled items)
     */
    get visibleItems(): IItemConfig[] {
        if (this.hideDisableItems) {
            return this.items.filter(item => !item.disabled);
        }
        return this.items;
    }

    ngOnInit(): void {
        // Drag and drop functionality is now implemented using Angular CDK
    }

    ngOnDestroy(): void {
        // No cleanup needed for Angular CDK drag-drop
    }

    /**
     * Handles drag and drop events to reorder items
     * @param event The CDK drop event
     */
    onDrop(event: CdkDragDrop<IItemConfig[]>): void {
        if (event.previousIndex !== event.currentIndex) {
            // Get the items being moved in the visible array
            const movedItem = this.visibleItems[event.previousIndex];
            const targetItem = this.visibleItems[event.currentIndex];
            
            // Find the actual indices in the main items array
            const actualPreviousIndex = this.items.findIndex(item => item.id === movedItem.id);
            const actualCurrentIndex = this.items.findIndex(item => item.id === targetItem?.id);
            
            if (actualPreviousIndex !== -1 && actualCurrentIndex !== -1) {
                // Move the item in the main items array
                moveItemInArray(this.items, actualPreviousIndex, actualCurrentIndex);
                
                // Emit the reordered items to parent component
                this.itemsReordered.emit(this.items);
                
                // Force change detection
                this.cdr.markForCheck();
                this.cdr.detectChanges();
                
                // Update the database with new sort order
                this.updateItemOrder();
            }
        }
    }

    /**
     * Updates the sort order of items in the database
     */
    private updateItemOrder(): void {
        
        const updatedItems: IItemConfig[] = this.itemConfigHierachyService.updateItemsSortOrder(this.items, null, false);
        
        if (updatedItems.length > 0) {
            this.itemConfigService.updateItems(updatedItems).subscribe({
                next: () => {
                    this.toastr.success("Changes have been successfully saved.");
                },
                error: (error) => {
                    this.toastr.error("Failed to save changes.");
                    // Optionally revert the UI changes here
                }
            });
        } else {
        }
    }

    /**
     * Custom drag start handler to create a clean preview
     */
    // onDragStarted(event: any): void {
    //     // Hide the default preview
    //     if (event.source && event.source.element) {
    //         const previewElement = event.source.element.nativeElement.cloneNode(true);
    //         
    //         // Clean up the preview element
    //         previewElement.style.background = 'white';
    //         previewElement.style.border = '1px solid #ddd';
    //         previewElement.style.borderRadius = '4px';
    //         previewElement.style.padding = '8px';
    //         previewElement.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
    //         previewElement.style.transform = 'rotate(2deg)';
    //         previewElement.style.opacity = '0.9';
    //         
    //         // Remove any problematic elements
    //         const problematicElements = previewElement.querySelectorAll('*::before, *::after');
    //         problematicElements.forEach((el: any) => el.remove());
    //     }
    // }

    onItemDeleted(item: IItemConfig): void {
        this.items = this.items.filter(itm => itm !== item);
        this.configItemDeleted.emit(item);
    }
}



